import React from "react";
import { useSearchParams } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import IELTSTestDetails from "../pages/IELTSTestDetails";

/**
 * Wrapper for the IELTS test details route.
 * When opened by admin (user=instructor & userId in query), the page is shared
 * and uses admin APIs with credentials: false. Skip ProtectedRoute so admin
 * can view without logging into the user frontend.
 * For students, require auth as usual.
 */
const IELTSTestDetailsRoute = () => {
  const [searchParams] = useSearchParams();
  const isAdminMode = searchParams.get("user") === "instructor" && searchParams.get("userId");

  if (isAdminMode) {
    return <IELTSTestDetails />;
  }

  return (
    <ProtectedRoute>
      <IELTSTestDetails />
    </ProtectedRoute>
  );
};

export default IELTSTestDetailsRoute;
